import {Injectable} from '@angular/core';

import {Http, Response}  from '@angular/http';
import {AuthHttp, AuthConfig} from 'angular2-jwt';

import {Observable}  from 'rxjs/Observable';
// import 'rxjs/add/observable/throw';

import {StoreService}  from '../../shared/store/store.service';
import {CognitoAuthService} from '../../shared/auth/cognito.service';
import { URLSearchParams } from '@angular/http/src/url_search_params';

@Injectable()
export class IsoService {

    iso: any = {}; // specific iso
    isos: any[ ] = []; // all isos

    maxIsoDataCallRetries = 0;
    isosDataSubscription;
    summarySubscription;

    idToken: string;

    private static extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    private static handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead

        return Observable.throw(errMsg);
    }

    constructor(private store: StoreService, private http: Http, private authHttp: AuthHttp, private cognitoAuthService: CognitoAuthService) {
    }

    // This service gets the ISO location for a customer (if it exists)
    getIsoLocation(params): Observable<any> {
        console.log('calling getIsoLocation');

        const self = this;
        return Observable.create(function(subscriber) {
            let doFetchIsosFromAPI = true; //XXX: set to get always for now
        
            // Fetch events from the API only if the events in the store on client are not fresh
            // i.e. if they are older than the life of the store
            if (doFetchIsosFromAPI) {

                self.cognitoAuthService.getIdTokenPromise().then(function (idToken) {

                    self.idToken = idToken;
                    if (!('customer_id' in params)) {
                        params['customer_id'] = self.cognitoAuthService.decodeToken(idToken)['custom:customer'];
                    }
                    self.isosDataSubscription = self.callIsoLocationApi(params).subscribe(function (iso) {

                        self.iso = iso;
                        subscriber.next(iso);

                    }, function (err) {

                        // Retry fetching events until max number of retries is reached
                        self.isosDataSubscription.unsubscribe();
                        --self.maxIsoDataCallRetries;
                        if (self.maxIsoDataCallRetries > 0) {
                            self.createIso(params);
                        }
                    });
                }).catch(function (err) {

                    console.log('Error in getIdTokenPromise()');
                    console.log(err);

                });
            }
        });
    }

    // This service creates an Iso for a customer
    createIso(params): Observable<any> {
        console.log('calling createIso');

        const self = this;

        return Observable.create(function(subscriber) {
            let doFetchIsosFromAPI = true; //XXX: set to get always for now
        
            // Fetch events from the API only if the events in the store on client are not fresh
            // i.e. if they are older than the life of the store
            if (doFetchIsosFromAPI) {

                self.cognitoAuthService.getIdTokenPromise().then(function (idToken) {

                    self.idToken = idToken;
                    if (!('customer_id' in params)) {
                        params['customer_id'] = self.cognitoAuthService.decodeToken(idToken)['custom:customer'];
                    }
                    self.isosDataSubscription = self.callIsosApi(params).subscribe(function (iso) {

                        self.iso = iso;
                        subscriber.next(iso);

                    }, function (err) {

                        // Retry fetching events until max number of retries is reached
                        self.isosDataSubscription.unsubscribe();
                        --self.maxIsoDataCallRetries;
                        if (self.maxIsoDataCallRetries > 0) {
                            self.createIso(params);
                        }
                    });
                }).catch(function (err) {

                    console.log('Error in getIdTokenPromise()');
                    console.log(err);

                });
            }
        });
    }

    private callIsosApi(params): Observable<any> {

        // TODO: Use params to fetch filtered events from AWS instead of fetching all events
        console.debug('callIsosApi');

        const apiConfig = this.store.get('apiConfig');

        var headers = apiConfig.headers;
        headers['Authorization'] = this.idToken;

        // Mock request to a static events data file
        // return this.http.get('assets/data/users.json').map(userService.extractData).catch(userService.handleError);
        return this.http.post(apiConfig.isoCreateURL, params, {headers: headers})
            .map(IsoService.extractData)
            .catch(IsoService.handleError);
    }
    private callIsoLocationApi(params): Observable<any> {

        // TODO: Use params to fetch filtered events from AWS instead of fetching all events
        console.debug('callIsolocationApi');

        const apiConfig = this.store.get('apiConfig');

        var headers = apiConfig.headers;
        headers['Authorization'] = this.idToken;

        var label = params.customer_id;

        // Mock request to a static events data file
        // return this.http.get('assets/data/users.json').map(userService.extractData).catch(userService.handleError);
        return this.http.get(apiConfig.isoLocationURL + label, {headers: headers})
            .map(IsoService.extractData)
            .catch(IsoService.handleError);
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/iso/iso.service.ts